const PINATA_ENDPOINT =
	"https://bzz3kgsqj7.execute-api.us-east-2.amazonaws.com/default/ronin-metadata-microservice?token=";
const ALT_BASE = 'https://api.opensea.io/api/v1/assets?token_ids='
const ALT_PARAMS = "&order_direction=desc&asset_contract_address=0x2127fe7ffce4380459cced92f2d4793f3af094a4&limit=20&include_orders=true"
const OS_API_KEY = "301fa1117dd34053bf6e67185d91b5a2"
const TESTNET_BASE = "https://bhc-ipfs-data.mypinata.cloud/ipfs/QmS1yc9gMxgQVyQ3wq4c239J5WyJg4TTGtMjja8jXLBmzA/"
const OS_SHARE = 'https://opensea.io/assets/0x2127fe7ffce4380459cced92f2d4793f3af094a4/'

module.exports = { PINATA_ENDPOINT, ALT_BASE, ALT_PARAMS, OS_API_KEY, TESTNET_BASE, OS_SHARE };
